import React from "react";
import styled from "styled-components/native";
import { VDBText } from "../..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import { SelectedItemTheme } from "@components/atoms/Button/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTheme } from "styled-components/native";
import { View } from "react-native";
import { DefaultTheme } from "styled-components/native";
import { useEnableProductSpecificFilterButtonColor } from "@redux/slices/globalSlice";

type RangeFilterProps = {
  id: number;
  toValue: string;
  fromValue: string;
  children: any;
  isSelected: boolean;
  onClick: Function;
  style: any;
  selectedStyle: SelectedItemTheme;
  customTheme: boolean;
  label: string;
  isHovered: boolean;
};

const RangeFilterText = ({
  isSelected,
  style,
  selectedStyle,
  label,
  isHovered,
}: RangeFilterProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { user } = useUserInfo();
  const enableProductSpecificFilterButtonColor =
    useEnableProductSpecificFilterButtonColor();
  return (
    <View style={style}>
      <CustomView
        isSelected={isSelected}
        selectedStyle={selectedStyle}
        customTheme={
          !!user?.custom_theme && !enableProductSpecificFilterButtonColor
        }
        theme={theme}
        label={label}
        isHovered={isHovered}
      >
        {
          <VDBText
            textAlign="center"
            color={
              isSelected
                ? user?.custom_theme && !enableProductSpecificFilterButtonColor
                  ? theme["option-cont-active"]
                  : theme["core-05"]
                : theme["option-cont"]
            }
            type={typography["Body-M"]}
          >
            {label}
          </VDBText>
        }
      </CustomView>
    </View>
  );
};

const CustomView = styled.View<RangeFilterProps>`
  align-items: center;
  justify-content: center;
  background: ${({ theme }: { theme: DefaultTheme }) =>
    theme["option-bg-static"]};
  border-radius: ${SpaceType.Basic}px;
  padding: ${SpaceType.Basic}px ${SpaceType.Tiny}px;
  background-color: ${({
    isSelected,
    theme,
    selectedStyle,
    label,
    isHovered,
  }: {
    isSelected: boolean;
    theme: DefaultTheme;
    selectedStyle: SelectedItemTheme;
    label: string;
    isHovered: boolean;
  }) =>
    !label
      ? "transparent"
      : isSelected
      ? theme[
          selectedStyle.primary
            ? (selectedStyle.primary as keyof DefaultTheme)
            : "diam-03"
        ]
      : isHovered
      ? theme["option-bg-hover"]
      : theme["option-bg-static"]};
  overflow: hidden;
  border-width: 1px;
  border-color: ${({
    isSelected,
    theme,
    selectedStyle,
    customTheme,
    label,
  }: {
    isSelected: boolean;
    theme: DefaultTheme;
    selectedStyle: SelectedItemTheme;
    customTheme: boolean;
    label: string;
  }) =>
    !label
      ? "transparent"
      : isSelected
      ? customTheme
        ? selectedStyle.primary
        : theme[
            selectedStyle.secondary
              ? (selectedStyle.secondary as keyof DefaultTheme)
              : "diam-04"
          ]
      : theme["option-bg-static"]};
`;

export default RangeFilterText;
